import { FormikValues } from 'formik'

import { PositionCreateInput } from '../../../__generated__/graphql'
import { PositionCreateFormValues } from '../../position/createPosition/buildPositionCreateInitialValues'
import { toPositionCreateInput } from '../../position/createPosition/toPositionCreateInput'
import prepareFormValues from '../../../utils/prepareFormValues'

export type WebsiteCreatePositionDraft = PositionCreateFormValues & {
  draftId: string
}

const createDraftId = (): string =>
  globalThis.crypto?.randomUUID?.() ?? `draft-${Date.now()}-${Math.random().toString(36).slice(2)}`

export const createPositionDraft = (
  position: Omit<WebsiteCreatePositionDraft, 'draftId'>
): WebsiteCreatePositionDraft => ({
  ...position,
  draftId: createDraftId(),
})

export const stripPositionDraftId = ({ draftId, ...rest }: WebsiteCreatePositionDraft): PositionCreateFormValues => {
  void draftId
  return rest
}

export const positionDraftToCreateInput = (
  draft: WebsiteCreatePositionDraft,
  websiteId: string | number
): PositionCreateInput => toPositionCreateInput(prepareFormValues(stripPositionDraftId(draft)), websiteId)

export const getWebsiteCreatePositionDrafts = (values: FormikValues): WebsiteCreatePositionDraft[] =>
  (values.positions as WebsiteCreatePositionDraft[] | undefined) ?? []
